"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["className", "children", "label", "labelClassname", "wrapperClassName", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _fieldsize = _interopRequireWildcard(require("../form/fieldsize"));
var _label = _interopRequireDefault(require("./label"));
var _rowModule = _interopRequireDefault(require("./row.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
//  Form row
// =========

const Row = _ref => {
  let {
      className,
      children,
      label,
      labelClassname,
      wrapperClassName,
      size
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const classNames = (0, _classnames.default)(_rowModule.default.Row, className, {
    [_rowModule.default.RowDefault]: size === _fieldsize.default.DEFAULT,
    [_rowModule.default.RowSmall]: size === _fieldsize.default.SMALL
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(_rowModule.default.rowWrapper, wrapperClassName)
  }, restProps), label && /*#__PURE__*/_react.default.createElement(_label.default, {
    className: labelClassname
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames
  }, children));
};
Row.propTypes = {
  size: _propTypes.default.string,
  className: _propTypes.default.string,
  labelClassname: _propTypes.default.string,
  wrapperClassName: _propTypes.default.string,
  label: _propTypes.default.string,
  children: _propTypes.default.node
};
Row.defaultProps = _objectSpread({}, _fieldsize.fieldSizeDefaultProps);
var _default = exports.default = Row;